import styled, { keyframes } from "styled-components";
import { VipPageView } from ".";

const spin = keyframes`
    to { transform: rotate(360deg); }
`;

export const VipCoachWrapper = styled.div`
    width: 100%;
    height: 100%;`
;

export const PageSpinnerWrapper = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    z-index: 10;
`;

export const PageSpinner = styled.span`
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 3px solid rgba(253, 51, 0, 0.25);
    border-top-color: #fd3300;
    border-radius: 50%;
    animation: ${spin} 0.7s linear infinite;
`;

export const VipCoachPage = styled.div<{ $pageState: VipPageView, $userRole?: string }>`
    position: relative;
    background-color: ${({ $pageState, $userRole }) =>
        ($userRole === 'subscriber' && $pageState === 'chat') ? '#f8f8f8' : '#fff'
    };
    height: 100%;
    min-height: 400px;
    padding-left: ${({ $pageState }) => $pageState === 'onboarding' ? '30px' : '16px'};
    padding-right: ${({ $pageState }) => $pageState === 'onboarding' ? '30px' : '16px'};

    @media (max-width: 768px) {
        padding-left: 16px;
        padding-right: 16px;
        background-color: ${({ $pageState }) => $pageState === 'chat' ? '#f8f8f8' : '#fff'};
    }
`;

export const VipCoachingPageWrapper = styled.div<{ $pageState: VipPageView, $userRole?: string }>`
    display: flex;
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;
    height: 100%;

    ${({ $pageState, $userRole }) => $pageState === 'init' && $userRole === 'coach' && `
        @media (min-width: 769px) {
            padding-top: 20px;
            padding-left: 16px;
            padding-right: 16px;
        }
    `}
`;

export const BreadCrumbWrapper = styled.div<{ $pageState: VipPageView, $userRole?: string }>`
    margin-top: 20px;
    margin-bottom: -10px;

    ${({ $pageState, $userRole }) => $userRole === 'coach' && $pageState === 'init' && `
        @media (max-width: 767px) {
            display: none;
        }
    `}

    ${({ $pageState, $userRole }) => $userRole === 'coach' && $pageState === 'chat' && `
        @media (min-width: 769px) {
            margin-top: 60px;
            margin-bottom: 25px;
        }
        @media (max-width: 768px) {
            display: none;
        }
    `}
`;

export const Title = styled.h1`
    font-family: 'Repro', sans-serif;
    font-weight: 700;
    font-size: 70px;
    line-height: 1;
    text-transform: uppercase;
    margin: 25px 0;

    @media (max-width: 768px) {
        font-size: 36px;
        margin-top: 25px;
        margin-bottom: 15px;
    }
`;

export const HelperWrapper = styled.div<{ $pageState?: VipPageView }>`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #ece9e4;
    padding-bottom: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 10px;
        border-bottom: ${({ $pageState }) => ($pageState === 'chat' || $pageState === 'init' ? '1px solid #ece9e4' : 'none')};
        padding-bottom: ${({ $pageState }) => ($pageState === 'chat' || $pageState === 'init' ? '5px' : '25px')};
        text-align: ${({ $pageState }) => ($pageState === 'chat' ? 'left' : 'center')};
        margin-top: 10px;
    }
`;

export const HelperTitle = styled.div<{ $pageState?: VipPageView }>`
    font-family: 'Repro', sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 1;
    text-transform: uppercase;

    @media (max-width: 768px) {
        border-bottom:  ${({ $pageState }) => ($pageState === 'chat' ? 'none' : '1px solid #ece9e4')};
        padding-bottom: ${({ $pageState }) => ($pageState === 'chat' ? '0' : '16px')};
    }
`;

export const HelperLink = styled.p<{ $pageState?: VipPageView }>`
    font-family: 'Repro', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.22;
    color: #7b726c;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
    cursor: pointer;
    
    @media (max-width: 768px) {
        text-align: ${({ $pageState }) => ($pageState === 'chat' ? 'left' : 'center')};
        justify-content: ${({ $pageState }) => ($pageState === 'chat' ? 'flex-start' : 'center')};
    }
`;

export const HelperIcon = styled.img`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    display: inline-block;
`;

export const UploadsIndicatorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 100px;
    @media (max-width: 768px) {
        width: 100%;
        gap: 0;
        justify-content: space-between;
    }
`;

export const UploadsIndicatorLink = styled.button`
    font-family: 'Repro', sans-serif;
    font-size: 22px;
    font-weight: 500;
    line-height: 1;
    text-transform: uppercase;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: inherit;

    &:hover {
        opacity: 0.7;
    }

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const MobileChatIndicatorWrapper = styled.div`
    margin-bottom: 20px;
    @media (min-width: 769px) {
        display: none;
    }
`;

export const HelloMessageCoach = styled.h1`
    font-family: 'Repro', sans-serif;
    font-size: 30px;
    line-height: 30px;
    font-weight: 600;
    line-height: 1.22;
    margin-top: 28px;
    margin-bottom: 15px;

    @media (max-width: 768px) {
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 40px;
        margin-top: 50px;
    }
`;

export const CoachChatTitle = styled.h1`
    font-family: 'Repro', sans-serif;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: -15px;

    @media (max-width: 768px) {
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px;

        margin-top: 40px;
        margin-bottom: 10px;
    }
`;